import './App.css';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';

// Send the httpOnly auth cookie with every same-site API request.
axios.defaults.withCredentials = true;

import Navbar from './components/Navbar';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import SiteFooter from './components/SiteFooter';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './routes/AppRoutes';
import { useBackendHealthPing } from './hooks/useBackendHealthPing';

function App() {
  useBackendHealthPing();

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <AppRoutes />
          <SiteFooter />
          <PWAInstallPrompt />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
